import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { IconComponent } from '@nagel-assests';
import { TourPointConfig } from 'apps/nagel-cal-disposition/src/models/planningPageTypes';
import { DraggableCardInfoChipComponent } from '../../draggable-card/draggable-card-info-chip/draggable-card-info-chip.component';
import { EXPANDABLE_TOUR_POINT_TYPES } from '../../../configuration/consts/pickupPlanning';
import {
    BORDER_CROSSING_TOUR_POINT_TYPE,
    CUSTOMS_TOUR_POINT_TYPE,
    DELIVERY_TOUR_POINT_TYPE,
    EXCHANGE_OF_CARRIER_TOUR_POINT_TYPE,
    FINISH_TOUR_POINT_TYPE,
    PICKUP_TOUR_POINT_TYPE,
    START_TOUR_POINT_TYPE
} from '../../../utils/tourPointsUtils';
import { DriveInstructionsDrawerService } from '../../../services/drive-instructions-drawer.service';

@Component({
    selector: 'cal-group-tour-point',
    standalone: true,
    imports: [
        MatDividerModule,
        IconComponent,
        DraggableCardInfoChipComponent
    ],
    templateUrl: './groupTourPoint.component.html',
    styleUrl: './groupTourPoint.component.scss'
})
export class GroupTourPointComponent {
    @Input() id: string = '';
    @Input() selected: boolean = false;

    @Input() tourPointConfig: TourPointConfig = {
        tourpointId: 0,
        type: 1,
        sequenceNumber: 1,
        trafficIcon: 'ArrowUp',
        name: '',
        street: '',
        country: '',
        postalCode: '',
        city: '',
        locationIdentifier: '',
        plannedArrivalTime: null,
        plannedDepartureTime: null,
        weight: null,
        floorPalletSpaces: 0,
        floorPalletSpacesIdentifier: '',
        volumePalletSpaces: 0,
        volumePalletSpacesIdentifier: '',
        uniqueClientsCount: 0,
        uniqueTrafficFlows: '',
        productGroups: [],
        legCards: []
    };

    @Output() clickHandler = new EventEmitter<MouseEvent>();

    constructor(private driveInstructionsDrawerService: DriveInstructionsDrawerService) {}

    handleClick(event: MouseEvent) {
        if (EXPANDABLE_TOUR_POINT_TYPES.includes(this.tourPointConfig.type)) {
            this.clickHandler.emit(event);
        }
    }

    handleKeydown(/*event: KeyboardEvent*/) {
    }

    getTourPointLabel = () => {
        const supportedTourPointTypesLabels = {
            [BORDER_CROSSING_TOUR_POINT_TYPE]: $localize`Border`,
            [CUSTOMS_TOUR_POINT_TYPE]: $localize`Customs processing`,
            [EXCHANGE_OF_CARRIER_TOUR_POINT_TYPE]: $localize`Exchange of carrier`,
            [START_TOUR_POINT_TYPE]: $localize`Start`,
            [FINISH_TOUR_POINT_TYPE]: $localize`Finish`,
        };

        if (this.getIsFromThirdPartySystem()) {
            return '';
        }

        return  supportedTourPointTypesLabels[this.tourPointConfig.type as keyof typeof supportedTourPointTypesLabels] || '';
    };

    getIconType = () => {

        const supportedTourPointTypesIcons = {
            [PICKUP_TOUR_POINT_TYPE]: 'circle_arrow_up',
            [DELIVERY_TOUR_POINT_TYPE]: 'circle_arrow_down',
            [START_TOUR_POINT_TYPE]: 'flag_icon',
            [FINISH_TOUR_POINT_TYPE]: 'finish_flag',
            [EXCHANGE_OF_CARRIER_TOUR_POINT_TYPE]: 'exchange_of_carrier_icon',
            [BORDER_CROSSING_TOUR_POINT_TYPE]: 'border',
            [CUSTOMS_TOUR_POINT_TYPE]: 'customs_processing'
        };

        return supportedTourPointTypesIcons[this.tourPointConfig.type as keyof typeof supportedTourPointTypesIcons]  || '';
    };

    getIsFromThirdPartySystem = (): boolean => {
        return this.driveInstructionsDrawerService.isFromThirdPartySystem(this.tourPointConfig);
    };
}